import localforage from 'localforage';

/**
 * Gerenciador de save usando IndexedDB (via localforage).
 * Auto-save a cada intervalo configuravel.
 */
export class SaveManager {
  private store: LocalForage;
  private autoSaveInterval: number | null = null;

  constructor(gameName: string) {
    this.store = localforage.createInstance({
      name: 'universe-axiom-games',
      storeName: gameName,
    });
  }

  async save(key: string, data: unknown): Promise<void> {
    const saveData = {
      data,
      timestamp: Date.now(),
      version: 1,
    };
    await this.store.setItem(key, saveData);
  }

  async load<T>(key: string): Promise<{ data: T; timestamp: number } | null> {
    const result = await this.store.getItem<{ data: T; timestamp: number }>(key);
    return result;
  }

  async deleteSave(key: string): Promise<void> {
    await this.store.removeItem(key);
  }

  startAutoSave(key: string, getData: () => unknown, intervalMs = 30000) {
    this.stopAutoSave();
    this.autoSaveInterval = window.setInterval(() => {
      this.save(key, getData());
    }, intervalMs);
  }

  stopAutoSave() {
    if (this.autoSaveInterval !== null) {
      clearInterval(this.autoSaveInterval);
      this.autoSaveInterval = null;
    }
  }

  async exportSave(key: string): Promise<string> {
    const data = await this.store.getItem(key);
    return btoa(JSON.stringify(data));
  }

  async importSave(key: string, encoded: string): Promise<void> {
    const data = JSON.parse(atob(encoded));
    await this.store.setItem(key, data);
  }
}
